import logo from './logo.svg';
import axios from "axios";
export default function App() {
 async function bok() {
   let response = await axios.get("/api/online-devices");
   let cert = response.request;
   console.log(cert)
 }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" onClick={bok} />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}
